import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { PurchaseOrderDetailsContext, PurchaseOrderDetailsValues } from '../../contexts/PurchaseOrderDetailsContext';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CloseDialogAction } from '../../../../components/shared/dialogs/CloseDialogAction';

export const PurchaseOrderDetailsStockCheckModal = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('purchaseOrderDetails');

  const { acceptStockCountModal, isStockCheckModalOpen, closeStockCountModal } = useContext(PurchaseOrderDetailsContext) as PurchaseOrderDetailsValues;

  const goToStockCheck = () => {
    navigate('/store/stock-count');
  };

  return (
    <Dialog onClose={closeStockCountModal}
      open={isStockCheckModalOpen}>
      <DialogTitle>
        {t('stockCheckModal.title')}
        <CloseDialogAction onCancel={closeStockCountModal} />
      </DialogTitle>
      <DialogContent>
        <Typography>
          {t('stockCheckModal.body')}
        </Typography>
      </DialogContent>
      <DialogActions>

        <Stack direction={{ xs: 'column', md: 'row' }}
          gap='6px'
          width='100%'>
          <Button variant='badSecondary'
            fullWidth
            size="lg"
            onClick={acceptStockCountModal}>
            {t('stockCheckModal.continueAnyway')}
          </Button>
          <Button variant='primary'
            fullWidth
            size="lg"
            onClick={goToStockCheck}>
            {t('stockCheckModal.viewStockCounts')}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};